import React,{useEffect, useRef} from 'react';
import Skill from './Skill/Skill.js';
import SkillsStyles from './Skills.module.css';
import {skillsHeaderClickHandler,skillsContainerMouseDownHandler,skillsContainerMouseLeaveHandler,skillsContainerMouseMoveHandler,skillsContainerMouseUpHandler} from './SkillsEventHandlers.js';


export default function Skills(){
    const skillsSectionRef=useRef(null);
    const skillsHeaderRef=useRef(null);
    const skillsContainerRef=useRef(null);
    const skillBoxesRef=useRef([]);
    useEffect(()=>{
        skillsHeaderRef.current.addEventListener('click',skillsHeaderClickHandler.bind(null,{skillsContainerRef}));
        skillsContainerRef.current.addEventListener('mousedown',skillsContainerMouseDownHandler.bind(null,{skillsContainerRef}))
        skillsContainerRef.current.addEventListener('mouseleave',skillsContainerMouseLeaveHandler.bind(null,{skillsContainerRef}))
        skillsContainerRef.current.addEventListener('mousemove',skillsContainerMouseMoveHandler.bind(null,{skillsSectionRef,skillsContainerRef,skillBoxesRef}))
        skillsContainerRef.current.addEventListener('mouseup',skillsContainerMouseUpHandler.bind(null,{skillsSectionRef,skillBoxesRef}))
    });
    return <section ref={skillsSectionRef} id={SkillsStyles.Skills}>
                <h1 ref={skillsHeaderRef} id={SkillsStyles.SkillsHeading}>My Skills</h1>
                <div ref={skillsContainerRef} id={SkillsStyles.SkillsContainer}>
                    <Skill refsArray={skillBoxesRef} imagePath="https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/1024px-HTML5_logo_and_wordmark.svg.png"
                        name="HTML"
                    />
                    <Skill refsArray={skillBoxesRef} name="CSS"
                        imagePath="https://3.bp.blogspot.com/-oRSUw_TmO9o/XIb61m88fcI/AAAAAAAAIq0/vnxl2zzsXEQsnHI2fH4GjKu_ZT0urRo4wCK4BGAYYCw/s1600/icon%2Bcss%2B3.png"
                    />
                    <Skill refsArray={skillBoxesRef} name="Javascript"
                        imagePath="https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg"
                    />
                    <Skill refsArray={skillBoxesRef} name="Typescript"
                        imagePath="https://www.flaticon.com/svg/static/icons/svg/919/919832.svg"
                    /> 
                    <Skill refsArray={skillBoxesRef} name="React" 
                        imagePath="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
                    />
                    <Skill refsArray={skillBoxesRef} name="C++"
                        imagePath="https://user-images.githubusercontent.com/42747200/46140125-da084900-c26d-11e8-8ea7-c45ae6306309.png"
                    />
                    <Skill refsArray={skillBoxesRef} name="C#"
                        imagePath="https://upload.wikimedia.org/wikipedia/commons/7/7a/C_Sharp_logo.svg"
                    />
                    <Skill refsArray={skillBoxesRef} name="Unity"
                        imagePath="https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/unity-512.png"
                    />
                </div>
        </section>
}